import * as types from './constants';

// Get Promotions
export const getPromotionsRequest = data => (
  { type: types.GET_PROMOTIONS_REQUEST, payload: data }
);

export const getPromotionsDone = data => (
  { type: types.GET_PROMOTIONS_DONE, payload: data }
);

export const getPromotionsFailed = errors => (
  { type: types.GET_PROMOTIONS_FAILED, payload: errors }
);

export const getPromotionsReset = () => (
  { type: types.GET_PROMOTIONS_RESET }
);

// Operations
export const promotionsSetPage = data => (
  { type: types.PROMOTIONS_SET_PAGE, payload: data }
);